<template>
  <div class="container">
    <div class="info">
      <!-- 详情 -->
      <div class="content">
        <!-- 标题 -->
        <div class="title">{{ $t('login').title }}</div>
        <!-- 切换 -->
        <div class="tabs">
          <span :class="loginType == 'Email' ? 'active' : ''" @click="loginType = 'Email'"
            v-if="loginTypeArr.includes('Email')">{{ $t('register').Mailbox
            }}</span>
          <span :class="loginType == 'Phone' ? 'active' : ''" @click="loginType = 'Phone'"
            v-if="loginTypeArr.includes('Phone')">{{ $t('register').PhoneNumber
            }}</span>
        </div>
        <!-- 电子邮箱 -->
        <div class="item" v-if="loginType == 'Email'">
          <van-field v-model="Email" :placeholder="$t('register').placeholder5">
          </van-field>
        </div>
        <!-- 手机号-->
        <div class="item" v-if="loginType == 'Phone'">
          <van-field v-model="PhoneNumber" type="tel" :placeholder="$t('register').placeholder0">
            <template #left-icon>
              <VueCountryIntl schema="popover" v-model="PhoneNumberCode" :listZIndex="10000"
                popoverClass="selectCountry2" :searchInputPlaceholder="$t('register').searchCountryMsg"
                @onChange="selectCountry">
                <i class="select_btn" slot="reference" @click="selectCountry">
                  <span> +{{ PhoneNumberCode }}</span>
                  <van-icon name="play" size="13" class="ric" color="var(--text_color)" />
                  <div class="line"></div>
                </i>
              </VueCountryIntl>
            </template>
          </van-field>
        </div>
        <!-- 密码 -->
        <div class="item">
          <van-field v-model="Password" :type="psdType" :placeholder="$t('login').placeholder1"
            :right-icon="psdType === 'password' ? 'eye' : 'closed-eye'"
            @click-right-icon="psdType = psdType === 'password' ? 'text' : 'password'">
          </van-field>
        </div>
        <div class="passInfo">
          <!-- 记住密码 -->
          <van-checkbox icon-size="14" v-model="checkedPass" checked-color="var(--text_color)">{{
            $t('login').rememberpassword }}</van-checkbox>
          <!-- 忘记密码 -->
          <div class="forget" @click="$router.push({ name: 'ForgotPassword' })">{{ $t('login').ForgotPassword }}</div>
        </div>
        <!-- 按钮 -->
        <van-button block @click="handleSub">{{ $t('login').btn }}</van-button>
        <!-- 注册 -->
        <div class="tips" @click="$router.push({ name: 'Register' })">{{ $t('login').noAccount }}<span>{{
          $t('login').Registration }}</span> </div>
      </div>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user'
import systemApi from '@/api/system'
import { Token } from '@/utils/mm'
import { EventBus } from '@/utils/event-bus'

export default {
  components: {
  },
  data() {
    return {
      loginTypeArr: [],//支持的登录方式
      loginType: 'Email',
      PhoneNumberCode: '1', //手机区号
      checkedPass: true,//记住密码
      checkedAgree: true,//同意协议
      PhoneNumber: '', //手机号
      Email: '',//邮箱
      Password: '',//密码
      psdType: "password", //输入框类型
    }
  },
  computed: {
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getConfig()
  },
  methods: {
    // 获取配置
    async getConfig() {
      const res = await systemApi.getConfig()
      if (res.systemSetting.loginType) {
        this.loginTypeArr = res.systemSetting.loginType
        this.loginType = this.loginTypeArr[0]
      }
      //记住密码
      var loginData = localStorage.getItem('loginData')
      if (loginData) {
        loginData = JSON.parse(loginData)
        this.loginType = loginData.loginType
        this.Password = loginData.passWord
        // 手机号
        if (this.loginType == 'Phone') {
          this.PhoneNumber = loginData.userName
        }
        // 邮箱
        if (this.loginType == 'Email') {
          this.Email = loginData.userName
        }
      }
    },
    // 选择国家区号
    selectCountry() {
      this.$nextTick(() => {
        const searchInput = document.querySelector(
          '.selectCountry2 .search-input'
        )
        if (searchInput) {
          searchInput.style.width = '90%'
          searchInput.style.height = 'auto'
        }
      })
    },
    // 提交登录
    async handleSub() {
      if (!this.checkForm()) return
      const form = {
        loginType: this.loginType,
        passWord: this.Password,
      }
      // 手机号
      if (this.loginType == 'Phone') {
        form.userName = this.PhoneNumber
      }
      // 邮箱
      if (this.loginType == 'Email') {
        form.userName = this.Email
      }
      let res = await userApi.login(form)
      this.$toast.success(this.$t('login').success)
      //记住密码 存缓存
      if (this.checkedPass) {
        localStorage.setItem('loginData', JSON.stringify(form))
      } else {
        localStorage.removeItem('loginData')
      }
      Token.set(res.token)
      EventBus.$emit('Login')
      this.$router.push({ name: 'Home' })
    },
    // 表单验证
    checkForm() {
      // 手机号
      if (this.loginType == 'Phone') {
        if (!this.PhoneNumber) {
          this.$toast({
            message: this.$t('login').placeholder,
            position: 'center'
          })
          return false
        }
      }
      // 邮箱
      if (this.loginType == 'Email') {
        if (!this.Email) {
          this.$toast({
            message: this.$t('register').placeholder5,
            position: 'center'
          })
          return false
        }
      }
      // 密码
      if (!this.Password) {
        this.$toast({
          message: this.$t('login').placeholder1,
          position: 'center'
        })
        return false
      }
      return true
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  padding: 50px 15px 15px 15px;
  background: var(--background_color);
  min-height: 100vh;
  padding-top: 110px;
  padding-bottom: 80px;
  width: 100%;
  background: var(--background_color);

  .info {
    margin: 0 auto;
    max-width: 500px;

    .content {
      margin-top: 40px;
      background: var(--info_color);
      border-radius: 25px;
      padding: 40px;
      box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.3);

      .title {
        font-size: 35px;
        font-weight: bold;
        color: var(--text_color);
      }

      .tabs {
        margin: 40px 0;
        font-size: 16px;
        color: var(--ntext_color);

        span {
          margin-right: 20px;
          padding: 0 20px;
        }

        .active {
          color: var(--text_color);
          padding-bottom: 10px;
          border-bottom: 2px solid var(--text_color);
        }
      }

      .item {
        margin-top: 15px;

        .select_btn {
          font-size: 16px;
          color: var(--text_color);
          margin-right: 10px;
          display: flex;
          align-items: center;

          .ric {
            transform: rotate(90deg);
            margin: 0 10px 0 5px;
          }

          .line {
            height: 15px;
            background: var(--ntext_color);
            width: 1px;
          }
        }
      }

      .passInfo {
        margin: 5px 10px 0 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: var(--text_color);
        font-size: 14px;

        .forget:hover {
          opacity: 0.8;
        }
      }

      .van-button {
        margin-top: 50px;
        background: var(--text_color);
        height: 50px;
        border-radius: 25px;
        border: 0;
        font-size: 16px;
        color: var(--background_color);
      }

      .van-button:hover {
        opacity: 0.8;
      }

      .tips {
        margin-top: 15px;
        text-align: center;
        color: var(--ntext_color);
        font-size: 14px;

        span {
          color: var(--text_color);
          text-decoration: underline;
        }

        span:hover {
          opacity: 0.8;
        }
      }

    }
  }
}

::v-deep .van-field__value {
  overflow: visible;
  display: grid;
}

::v-deep .van-cell {
  background: var(--info_color);
  padding: 0 15px;
  height: 60px;
  margin-bottom: 10px;
  border-radius: 10px;
  font-size: 16px;
  border: 1px solid var(--ntext_color);
}

::v-deep .van-field__control {
  color: var(--text_color);
}

::v-deep .van-field__control::-webkit-input-placeholder {
  color: var(--ntext_color);
  font-size: 16px;
  opacity: 0.9;
}

::v-deep .van-field__left-icon {
  align-items: center;
  display: flex;
}

::v-deep .van-checkbox__icon--checked .van-icon {
  color: var(--background_color);
}

::v-deep .van-checkbox__label {
  margin-left: 5px;
  color: var(--text_color);
  font-size: 14px;
}
</style>
